/**
 * Creates a new object by picking specific keys from an existing object.
 *
 * @template T - The type of the object to pick keys from.
 * @template K - The union type of keys to pick.
 *
 * @param {T} obj - The object to pick keys from.
 * @param {K[]} keys - An array of keys to pick.
 *
 * @returns {Pick<T, K>} - A new object containing only the specified keys and their values.
 */
export const pick = <T, K extends keyof T>(obj: T, keys: K[]): Pick<T, K> => {
  const result: Partial<Pick<T, K>> = {};
  for (const key of keys) {
    if (obj && Object.prototype.hasOwnProperty.call(obj, key)) {
      result[key] = obj[key];
    }
  }
  return result as Pick<T, K>;
};
